import { render } from "./WebCatalogGroups.vue?vue&type=template&id=9f441aae"
import script from "./WebCatalogGroups.vue?vue&type=script&lang=js"
export * from "./WebCatalogGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WebOrders/WebCatalogGroups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f441aae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f441aae', __exports__)) {
    api.reload('9f441aae', __exports__)
  }
  
  module.hot.accept("./WebCatalogGroups.vue?vue&type=template&id=9f441aae", () => {
    api.rerender('9f441aae', render)
  })

}


export default __exports__